/**
 * Guest Join Route
 * Join via invitation token
 */
import { createFileRoute } from "@tanstack/react-router";
import { GuestJoinPage } from "../pages/GuestJoinPage";

export const Route = createFileRoute("/join/$token")({
  component: GuestJoinPage,
});
